<template>
    <router-view :key="$route.path" />

    <AgeModal />
</template>

<script>
    // import "primevue/resources/themes/lara-light-teal/theme.css";
    // import "primevue/resources/primevue.min.css";

    // import "@/assets/css/bootstrap.css";
    // import "@/assets/css/default.css";
    // import "@/assets/css/root_primary.css";
    // import "@/assets/css/style.css";

    // import { onBeforeMount } from "vue";

    // import { useRoute } from "vue-router";
    // import { useStore } from "@/store";

    // // import { useMeta } from 'vue-meta';
    // import { useHead } from "@vueuse/head";

    // import moment from 'moment-timezone';
    // import 'moment/locale/az';

    // import { G } from "@/_common";

    import AgeModal from '@/views/AgeModal.vue';

    export default {
        name: "App",
        components: {
            AgeModal,
        },
        setup() {
            // const store = useStore();
            // const route = useRoute();

            // G.currentRoute = route;

            // const TR = ref({});

            // const def_lang = route.params && route.params.lang ? route.params.lang : "az";
            // store.setLang(def_lang);
            // console.log(store.getLang());


            // moment.locale(def_lang);

            // moment.updateLocale('az', {
            //     months: [
            //         "Yanvar", "Fevral", "Mart", "Aprel", "May", "İyun",
            //         "İyul", "Avqust", "Sentyabr", "Oktyabr", "Noyabr", "Dekabr"
            //     ],
            //     monthsShort: [
            //         "Yan", "Fev", "Mar", "Apr", "May", "İyn",
            //         "İyl", "Avq", "Sen", "Okt", "Noy", "Dek"
            //     ],
            // });

            // useHead({
            //     title: 'Unudulmazlar',
            //     titleTemplate: null,
            //     htmlAttrs:{
            //         lang: 'az-AZ'
            //     },
            //     meta: [
            //         // { charset: 'utf-8' },
            //         { vmid: 'main', property: 'og:title', content: 'unudulmazlar.az' },
            //         { vmid: 'main', property: 'og:site_name', content: 'unudulmazlar.az' },
            //         { vmid: 'main', property: 'og:description', content: 'unudulmazlar.az, Azərbaycan qəhrəmanları, Şəhidlərimiz, Azərbaycan şəhidləri, Vətən müharibəsi şəhidləri, 44 gün Vətən müharibəsi' },
            //         { vmid: 'main', property: 'og:image', itemprop: 'image', content: 'https://unudulmazlar.az/favicon.png' },
            //         { vmid: 'main', property: 'og:url', content: 'https://unudulmazlar.az/' },
            //         { vmid: 'main', property: 'og:type', content: 'unudulmazlar.az' },
            //         { vmid: 'main', property: 'og:image:width', content: '256' },
            //         { vmid: 'main', property: 'og:image:height', content: '255' },

            //         { vmid: 'main', property: 'twitter:title', content: 'unudulmazlar.az' },
            //         { vmid: 'main', property: 'twitter:description', content: 'unudulmazlar.az, Azərbaycan qəhrəmanları, Şəhidlərimiz, Azərbaycan şəhidləri, Vətən müharibəsi şəhidləri, 44 gün Vətən müharibəsi' },
            //         { vmid: 'main', property: 'twitter:image', content: 'https://unudulmazlar.az/favicon.png' },
            //         { vmid: 'main', property: 'twitter:card', content: 'summary_large_image' },

            //     ]
            // });

            // onMounted(async() => {
            //     // console.log(document.getElementById("frontend_favicon1").getAttribute("href").replace("{favicon}", G.systemData.favicon.value));
            // });

            // onBeforeMount(async () => {

                // await ajax({
                //     url: store.getTranslations(),
                //     success: (e) => {
                //         // if (e && e.data) store.commit("setTranslations", e.data);
                //         store.setTranslations(e.data);
                //         TR.value = store.getTranslation();
                //         G.lang = TR.value;
                //     },
                //     // error: () => {
                //     //     // G.atoast.error('Server Connection Error !');
                //     //     return null;
                //     // }
                // });

                // await ajax({
                //     url: store.getSystemSettings('system'),
                //     success: async (x) => {
                //         let res = x.data || null;
                //         if ( x.status == 200 && res ) {
                //             if( res.company !== undefined ){
                //                 for(let a in res){
                //                     G.systemData[a] = {"value": res[a].value, "type": res[a].type};
                //                 }
                //                 document.getElementById("frontend_favicon1").setAttribute("href", G.systemData?.favicon?.value );
                //                 document.getElementById("frontend_favicon2").setAttribute("href", G.systemData?.favicon?.value );
                //                 document.getElementById("frontend_favicon3").setAttribute("href", G.systemData?.favicon?.value );
                //             }
                //             else{
                //                 G.systemData = res;
                //             }

                //             // G.systemData = res.reduce((m, o) => m.set(o.key, o), new Map);
                //             // console.log(G.systemData);
                //             // console.log(res.reduce((m, o) => m.set(o.key, o), new Map)); //.values();
                //             // console.log(res.reduce((m, o) => m.set(o.key, {"value": o.value, "type": o.type}), new Map)); //.values();
                //         }
                //     },
                //     // error: () => {
                //     //     // console.log(e);
                //     // }
                // });
            // });

            return { };
        },
    };
</script>


<style lang="scss">
    @import "~nprogress/nprogress.css";
    #nprogress .bar {
        height: 4px;
    }
    #nprogress .spinner {
        right: auto;
        top: 50%;
        left: 50%;
        z-index: 999999;
    }
    #nprogress .spinner-icon {
        width: 48px;
        height: 48px;
        border: solid 6px transparent;
        border-top-color: rgb(23, 60, 82);
        border-left-color: rgb(23, 60, 82);
        border-radius: 50%;
    }
    body{
        background-image: url('~/public/assets/images/bg_body.jpg');
    }
</style>
